import React from 'react';
import hero1Video from "./../../assets/video/hero1.m4v";
import hero1VideoEn from "./../../assets/video/gif-en.m4v";
import {useTranslation} from "react-i18next";

const Hero1 = () => {
	const { t } = useTranslation('common')
	return(
		<div className='hero-wrap'>
			<div className='hero-head'>
				<h3>{t('InfinityCommunication')}<span className='yellow'>... !</span></h3>
				<h2>
					{t('Platform')}
					<span className='green'>{t('OnlineEvent')}</span>
					{t('And')}
					<span className='green'>
						{t('Webconfrance')}
					</span>
				</h2>
			</div>
			<div className='hero-btns'>
				<a href='https://panel.bellmeet.com'>
					<button>{t('Free')}</button>
				</a>
			</div>
			<div className='hero1-video-wrap'>
				<video key={Math.random()} autoPlay playsInline muted loop>
					<source src={t('lang') === 'fa' ? hero1Video : hero1VideoEn} type="video/mp4" />
						Your browser does not support HTML video.
				</video>
				{/*<div className='video-bottom-wrap'>
					متن تست
				</div>*/}
			</div>
		</div>
	)
}

export default Hero1;